import React from 'react';
import './Stub.css';

function WorksOnCanvas() {
  return (
    <div className="stub-page">
      <h1>Works on Canvas</h1>
      <p>Coming soon.</p>
    </div>
  );
}

export default WorksOnCanvas;
